<template>
  <v-layout row justify-center>
    <v-dialog v-model="value" persistent max-width="800px">
      <v-card class="px-3">
        <v-card-title primary-title class="title">New Procedure</v-card-title>
        <v-card-text class="pa-0">
          <v-form ref="form" v-model="valid">
            <v-container grid-list-xs fluid>
              <v-layout row wrap>
                <v-flex xs12>
                  <async-autocomplete
                    single-line
                    label="Patient"
                    v-model="newProcedure.patient_id"
                    :rules="[requiredRule]"
                    url="/api/patients/search"
                    required
                    item-value="id"
                    item-text="name"
                    dense
                  ></async-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete
                    :rules="[requiredRule]"
                    required
                    :items="proceduresList"
                    v-model="newProcedure.procedures"
                    label="Select procedures "
                    item-value="id"
                    item-text="name"
                    multiple
                  ></v-autocomplete>
                </v-flex>

                <v-flex xs12 class="text-xs-right mt-3">
                  <v-btn flat @click="clean">Close</v-btn>

                  <v-btn class="mx-0" :loading="loading" color="primary" @click="submit">Save</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    edit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      valid: true,
      requiredRule: v => !!v || "This field is required.",
      loading: false,
      newProcedure: {
        patient_id: "",
        procedures: []
      }
    };
  },
  watch: {
    edit(val) {
      if (val) this.newProcedure = val;
    }
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.axios
          .post(
            `/api/patients/${this.newProcedure.patient_id}/procedures`,
            this.newProcedure
          )
          .then(resp => {
            this.$emit("saved", resp.data);
          })
          .finally(() => this.clean());
      }
    },
    clean() {
      this.newProcedure.procedures = [];
      this.newProcedure.patient_id = "";
      this.loading = false;
      this.$emit("input", false);
      this.$refs.form.reset();
    }
  },
  computed: {
    proceduresList() {
      return this.$store.getters["base/procedures"];
    }
  },
  mounted() {
    this.$store.dispatch("base/loadProcedures");
  }
};
</script>

<style lang="scss" scoped>
</style>